export default "__VITE_ASSET__BOwdL9Yi__"